"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/broadcast/types");
var _types2 = require("../../actions/program/types");
function liveSources() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload;
  if (type === _types2.BROADCAST_SET_PROGRAM) {
    var layers = payload.layers;
    return layers.map(function (layer) {
      var _layer$source;
      return layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source._id;
    });
  }
  if (type === "".concat(_types.GET_BROADCAST, "_SUCCESS")) {
    var _payload$program$laye, _payload$program;
    return (_payload$program$laye = (_payload$program = payload.program) === null || _payload$program === void 0 ? void 0 : _payload$program.layers.map(function (_ref) {
      var source = _ref.source;
      return source === null || source === void 0 ? void 0 : source._id;
    })) !== null && _payload$program$laye !== void 0 ? _payload$program$laye : [];
  }
  return state;
}
var _default = exports["default"] = liveSources;